/// <amd-module name="Repos/Discussion/Utils/Markdown" />
import { MarkdownRendererOptions } from "VSS/Features/Markdown/MarkdownRendererContracts";

export const previewOptions: MarkdownRendererOptions = { breaks: true, html: true };
